var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ibi-cont"},[_c('ChartsLayout',{attrs:{"chartview":_vm.chartview,"class_chart":"ibi-chart"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }